import { ComponentType } from '@angular/cdk/overlay';
import { InjectionToken, TemplateRef } from '@angular/core';

export const CONFIRMATION_DIALOG_COMPONENT_TYPE: InjectionToken<ComponentType<unknown>>
  = new InjectionToken<ComponentType<unknown>>('Confirmation Dialog component constructor');

export interface ConfirmationDialogData {
  title: string;
  content?: TemplateRef<unknown>;
  confirm: string;
  decline: string;
}
